import axios from 'axios';

// PROD ENDPOINTS
let cms_endpoint_prefix = 'https://www.dayton.com/external-feeds/json/apps/v1/?id=';
let file_get_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/get_endpoint_data.php?endpoint=';
let api_GET_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/get_api_data.php?requested_set=';
let db_POST_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/post_to_db.php';
let db_PUT_prefix = 'https://projects.dayton.com/best_of_dayton_endpoints/put_to_db.php';
let timezone_data_endpoint = 'https://projects.dayton.com/best_of_dayton_endpoints/get_timezone_data.php';

// LOCALHOST ENDPOINT
if(document.domain == 'localhost') {
	let endpoint_path = 'http://localhost/bitbucket/best_of_dayton_pwa/endpoints/';
	cms_endpoint_prefix = 'https://www.dayton.com/external-feeds/json/apps/v1/?id=';
	file_get_prefix = endpoint_path+'get_endpoint_data.php?endpoint=';
	api_GET_prefix = endpoint_path+'get_api_data.php?requested_set=';
	db_POST_prefix = endpoint_path+'post_to_db.php';
	db_PUT_prefix = endpoint_path+'put_to_db.php';
	timezone_data_endpoint = endpoint_path+'get_timezone_data.php';
}

export default {

	/*cms_endpoint_prefix: 'https://www.dayton.com/external-feeds/json/apps/v1/?id=',
	file_get_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/get_endpoint_data.php?endpoint=',
	api_GET_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/get_api_data.php?requested_set=',
	db_POST_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/post_to_db.php',
	db_PUT_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints/put_to_db.php',
	timezone_data_endpoint: 'https://projects.dayton.com/best_of_dayton_endpoints/get_timezone_data.php',*/

	/*cms_endpoint_prefix: 'https://www.dayton.com/external-feeds/json/apps/v1/?id=',
	file_get_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/get_endpoint_data.php?endpoint=',
	api_GET_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/get_api_data.php?requested_set=',
	db_POST_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/post_to_db.php',
	db_PUT_prefix: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/put_to_db.php',
	timezone_data_endpoint: 'https://projects.dayton.com/best_of_dayton_endpoints_dev/get_timezone_data.php',*/

	/*cms_endpoint_prefix: 'https://www.dayton.com/external-feeds/json/apps/v1/?id=',
	file_get_prefix: '/best_of_dayton_endpoints/get_endpoint_data.php?endpoint=',
	api_GET_prefix: '/best_of_dayton_endpoints/get_api_data.php?requested_set=',
	db_POST_prefix: '/best_of_dayton_endpoints/post_to_db.php',
	db_PUT_prefix: '/best_of_dayton_endpoints/put_to_db.php',
	timezone_data_endpoint: '/best_of_dayton_endpoints/get_timezone_data.php',*/
	

	get_api_data: function(requested_set, options) {
		let rand = this.generate_random_string();
		let endpoint = api_GET_prefix + encodeURIComponent(requested_set) + '&rand=' + rand;

		// CHECK FOR OPTIONS
		if(options) {
			let options_qs = Object.keys(options).map(key => key + '=' + options[key]).join('&');
			endpoint += '&' + options_qs;
		}

		// console.log('endpoint for get request: ', endpoint);
		return axios.get(endpoint);
	},

	test_request: function() {
		return 'test';
	},
	
	get_cms_list: function(list_id) {
		let endpoint = file_get_prefix + encodeURIComponent(cms_endpoint_prefix + list_id);
		endpoint = this.generate_cacher_url('dcom_bod_list_'+list_id, endpoint);
		
		return axios.get(endpoint);
	},

	save_new_nomination: function(data) {
		let endpoint = db_POST_prefix;
		return axios.post(endpoint, data);
	},

	make_simple_post: function(data) {
		let endpoint = db_POST_prefix;
		return axios.post(endpoint, data);
	},

	get_timezone_data: function() {
		let rand = this.generate_random_string();
		let endpoint = timezone_data_endpoint + '?rand=' + rand;
		
		return axios.get(endpoint);
	},

	generate_random_string: function() {
		return Math.floor((Math.random() * 1000000) + 1);
	},

	generate_cacher_url: function(saveas, url_to_cache) {
		let cacher_url = 'https://host.coxmediagroup.com/cop/digital/common/cache/cacher.php';
		cacher_url += '?saveas=' + saveas;
		cacher_url += '&json_url='+encodeURIComponent(url_to_cache);
		
		return cacher_url;
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/http_services.js